import { createAction } from '@reduxjs/toolkit';
import { alertActions } from '_actions';
import { messageCenterService } from '_services';
import { ActionNames, Errors } from '_constants'

export const notesPendingActionActions = {
    load: () => dispatch => {
        dispatch(notesPendingActionActions.loadRequest());
        messageCenterService.loadNotesPendingAction()
            .then(
                messages => {
                    dispatch(notesPendingActionActions.loadSuccess(messages));
                },
                error => {
                    dispatch(notesPendingActionActions.loadFailure(error));
                    dispatch(alertActions.error(Errors.NOTES_PENDING_ACTION_LOAD_FAILURE));
                }
            );
    },
    loadRequest: createAction(ActionNames.NOTES_PENDING_ACTION_LOAD_REQUEST),
    loadSuccess: createAction(ActionNames.NOTES_PENDING_ACTION_LOAD_SUCCESS),
    loadFailure: createAction(ActionNames.NOTES_PENDING_ACTION_LOAD_FAILURE),

    deleteAll: (nonos) => dispatch => {
        dispatch(notesPendingActionActions.deleteAllRequest());
        messageCenterService.closeNotifications(nonos)
            .then(
                messages => {
                    dispatch(notesPendingActionActions.deleteAllSuccess(messages));
                },
                error => {
                    dispatch(notesPendingActionActions.deleteAllFailure({ nonos, error }));
                    dispatch(alertActions.error(Errors.NOTES_PENDING_ACTION_DELETE_ALL_FAILURE));
                }
            );
    },
    deleteAllRequest: createAction(ActionNames.NOTES_PENDING_ACTION_DELETE_ALL_REQUEST),
    deleteAllSuccess: createAction(ActionNames.NOTES_PENDING_ACTION_DELETE_ALL_SUCCESS),
    deleteAllFailure: createAction(ActionNames.NOTES_PENDING_ACTION_DELETE_ALL_FAILURE),

    setSelectedMessage: createAction(ActionNames.NOTES_PENDING_ACTION_SET_SELECTED_MESSAGE),

    changeSelection: (noteId) => (dispatch, getState) => {
        dispatch(notesPendingActionActions.setSelectedMessage({ noteId }));


        if (!getState().entities.notesPendingAction[noteId].isRead) {
            dispatch(notesPendingActionActions.markReadRequest({ noteId }));

            messageCenterService.markReadNotification(getState().entities.notesPendingAction[noteId].NONO)
                .then(
                    () => { dispatch(notesPendingActionActions.markReadSuccess(noteId)) }
                    ,
                    error => {
                        dispatch(notesPendingActionActions.markReadFailure({ noteId, error }));
                        dispatch(alertActions.error(Errors.NOTES_PENDING_ACTION_MARK_READ_FAILURE));
                    }
                );
        }
    },
    markReadRequest: createAction(ActionNames.NOTES_PENDING_ACTION_MARK_READ_REQUEST),
    markReadSuccess: createAction(ActionNames.NOTES_PENDING_ACTION_MARK_READ_SUCCESS),
    markReadFailure: createAction(ActionNames.NOTES_PENDING_ACTION_MARK_READ_FAILURE),


    delete: (nono) => (dispatch, getState) => {
        dispatch(notesPendingActionActions.deleteRequest({ nono }));

        let noteId = getState().entities.notesPendingAction[Object.keys(getState().entities.notesPendingAction)
            .find(x => getState().entities.notesPendingAction[x].NONO === nono)].id;
        messageCenterService.closeNotification(nono)
            .then(
                () => { dispatch(notesPendingActionActions.deleteSuccess({ nono, noteId })) }
                ,
                error => {
                    dispatch(notesPendingActionActions.deleteFailure({ nono, error }));
                    dispatch(alertActions.error(Errors.NOTES_PENDING_ACTION_DELETE_FAILURE));
                }
            );
    },
    deleteRequest: createAction(ActionNames.NOTES_PENDING_ACTION_DELETE_REQUEST),
    deleteSuccess: createAction(ActionNames.NOTES_PENDING_ACTION_DELETE_SUCCESS),
    deleteFailure: createAction(ActionNames.NOTES_PENDING_ACTION_DELETE_FAILURE),

}
